import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation } from 'react-router-dom';

const CustomCard = ({ data, loading, stats }) => {
    const defaultCards = [
        { label: 'Loading', value: 'Loading' },
        { label: 'Loading', value: 'Loading' },
        { label: 'Loading', value: 'Loading' },
        { label: 'Loading', value: 'Loading' }
    ];

    
    const cardsToDisplay = loading ? defaultCards : data;
    const location = useLocation();
    const isOverviewPage = location.pathname === "/overview-pdf";

    return (
        <Container fluid>
            <Row className="gap-3 px-5">
                {cardsToDisplay.map((item, index) => (
                    <Col
                        key={index}
                        className="col-lg col-5 col-12 rounded-4 p-3 mt-0 "
                        // style={{ background: "var(--color1)", height: "100px" }}
                        style={{
                            background: item.label === "Forecasted Budget" ? "var(--color2)" : "var(--color1)",
                            color: item.label === "Forecasted Budget" ? "white" : "var(--color4)",
                            // height: "100px"
                        }}

                    >
                        <p className="mb-1 small">
                            {loading ? (
                                <Skeleton
                                    width={80}
                                    height={20}
                                    baseColor="#ffe521"
                                    highlightColor="#fff899"
                                />
                            ) : (
                                item?.label
                            )}
                        </p>
                        {loading ? (
                            <div className="ps-2">
                                <div className="loader-small"></div>
                            </div>
                        ) : (
                            <>
                                <div className='d-flex align-items-center gap-2'>
                                    <h4 style={{ marginBottom: '2px' }}>{item?.value}</h4>
                                    {(() => {
                                        const change = stats?.comparison?.[item.label]?.change;
                                        const isNegative = typeof change === 'number' && change < 0;
                                        // const textColorClass = isNegative ? "text-danger" : "text-success";
                                        const bgColorClass = isNegative ? "bg-light-danger" : "bg-light-success";

                                        return (
                                            <>
                                                {item.label !== "Forecasted Budget" && isOverviewPage &&
                                                    <p className="small mb-0">
                                                        <span style={{ borderRadius: '100px', padding: "3px 9px" }} className={`fw-bold ${bgColorClass}`}>
                                                            {change !== undefined ? `${change > 0 ? '+' : ''}${change}%` : "-"}
                                                        </span>{" "}
                                                    </p>
                                                }
                                            </>
                                        );
                                    })()}
                                </div>

                                {item.label !== "Forecasted Budget" && isOverviewPage &&
                                    <span style={{ fontSize: '12px' }}>{stats?.comparedTo}</span>
                                }
                            </>
                        )}

                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default CustomCard;
